import api from "@/libs/axios";
import * as ep from "../../endpoints";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { hasError } from "@/utils/utils";
export default {
  namespaced: true,
  state: {
    statistics: [],
    loading: false,
    loadingUpdate: false,
    loadingCreate: false,
  },
  getters: {
    statistics(state) {
      return state.statistics;
    },
    loading(state) {
      return state.loading;
    },
  },
  mutations: {
    setStatistics(state, payload) {
      state.statistics = payload;
    },
    setLoading(state, val) {
      state.loading = val;
    },
  },
  actions: {
    async getStatistics(context, payload) {
      context.state.loading = true;
      await api.get(ep.STATISTICS).then((res) => {
        context.commit("setStatistics", res.data.data);
        context.state.loading = false;
      });
    },

    async createStatistics({ commit, dispatch }, payload) {
      commit("setLoading", true);
      try {
        const res = await api.post(ep.STATISTICS, payload);
        if (hasError(res.status)) throw res.status;
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت الإضافة بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        dispatch("getStatistics");
      } catch (err) {
        console.log(err);
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء إضافة البيانات",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
      } finally {
        commit("setLoading", false);
      }
    },

    async updateStatistics({ commit, dispatch }, payload) {
      commit("setLoading", true);
      try {
        const res = await api.put(
          ep.UPDATE_STATISTICS(payload.id),
          payload.data
        );
        if (hasError(res.status)) throw res.status;
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم التعديل بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        dispatch("getStatistics");
      } catch (err) {
        console.log(err);
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تعديل البيانات",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
      } finally {
        commit("setLoading", false);
      }
    },

    async deleteStatistics({ commit, dispatch }, payload) {
      commit("setLoading", true);
      try {
        const res = await api.delete(ep.UPDATE_STATISTICS(payload.id));
        if (hasError(res.status)) throw res.status;
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم الحذف بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        dispatch("getStatistics");
      } catch (err) {
        console.log(err);
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تعديل البيانات",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
      } finally {
        commit("setLoading", false);
      }
    },
  },
};
